import "./styles.scss";

import { FlagIcon } from "react-flag-kit";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import imgSalesLinkPNG from "../../../assets/images/affiliates/imgSalesLink.png";

function SalesLink() {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);
  const { affiliateInfo } = useSelector((state) => state.affiliateReducer);

  const urlUS = `https://www.lingofor.me/lingo-us/try/?user=${affiliateInfo?.slug}`;
  const urlES = `https://www.lingofor.me/lingo-es/conozca/?user=${affiliateInfo?.slug}`;
  const urlBR = `https://www.lingofor.me/lingo-pt/conheca/?user=${affiliateInfo?.slug}`;

  const arrayLanguage = [
    { id: 1, flag: "BR", url: urlBR, saleLink: "SALES_LINK_PT" },
    { id: 2, flag: "ES", url: urlES, saleLink: "SALES_LINK_ES" },
    { id: 3, flag: "US", url: urlUS, saleLink: "SALES_LINK_US" },
  ];

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      alert(t("COPIED_CLIPBOARD"));
    } catch (err) {
      console.error("Falha ao copiar texto: ", err);
    }
  };

  return (
    <div className="containerSalesLink">
      <h2 className="title">{user?.role === "student" || user?.role === "teacher" ? t("SALES_LINK") : ""}</h2>

      <div className="content">
        <img className="imgSalesLink" src={imgSalesLinkPNG} alt={t("SALES_LINK")} />

        <div className="divRight">
          <h4>{t("SELECT_THE_LINK")}</h4>

          <div className="wrapperLanguage">
            {arrayLanguage.map((item) => (
              <div key={item.id} className="wrapperLanguageContent">
                <div className="border">
                  <button type="button" className="btnLanguage" onClick={() => copyToClipboard(item.url)}>
                    <FlagIcon code={item.flag} />
                    <p>{t(item.saleLink)}</p>
                  </button>

                  <a className="textDescription" rel="noreferrer" href={item.url} target="_blank">
                    {item.url}
                  </a>

                  <button type="button" className="btnCopy" onClick={() => copyToClipboard(item.url)}>
                    {t("COPY")}
                  </button>
                </div>

                <div className="separator" style={item.id === 3 ? { display: "none" } : {}} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SalesLink;
